<template>
  <div class="vx-row">
    <div class="vx-col md:w-4/4 w-full mb-base">
      <vx-card>
        <!-- Filter Request Code -->
        <div class="vx-row mb-6">
          <div class="vx-col sm:w-1/6 w-full">
            <span>Device Request Code</span>
          </div>
          <div class="vx-col sm:w-2/5 w-full">
            <vs-input
              v-model="request_code"
              id="txt-search"
              type="text"
              placeholder="Device request code"
              class="w-full"
            />
          </div>
        </div>
        <!-- Filter Device Type -->
        <div class="vx-row mb-6">
          <div class="vx-col sm:w-1/6 w-full">
            <span>Device Type</span>
          </div>
          <div class="vx-col sm:w-2/5 w-full">
            <v-select
              autocomplete
              v-model="selected_type"
              placeholder="Select device type"
              :options="device_type"
            >
            </v-select>
          </div>
        </div>
        <!-- Filter Device -->
        <div class="vx-row mb-6">
          <div class="vx-col sm:w-1/6 w-full">
            <span>Device Code</span>
          </div>
          <div class="vx-col sm:w-2/5 w-full">
            <v-select
              id="cbo-merchant"
              inputId="txt-device"
              v-model="filter_device"
              placeholder="Select device"
              :options="device_list"
            >
            </v-select>
          </div>
        </div>

        <!-- Button -->
        <div class="vx-row mb-6">
          <div class="vx-col sm:w-1/6 w-full">
            <span>&nbsp;</span>
          </div>
          <div class="vx-col sm:w-2/3 w-full">
            <vs-button
              id="btn-filter"
              icon-pack="feather"
              icon="icon-search"
              v-on:click="fetchData(1, 20, true)"
              class="mr-3 mb-2 float-left"
              >Filter</vs-button
            >
            <vs-button
              id="btn-reset"
              icon-pack="feather"
              icon="icon-refresh-cw"
              color="warning"
              v-on:click="resetFilter()"
              class="mr-3 mb-2 float-left"
              >Reset</vs-button
            >
            <vs-button
              id="btn-create"
              icon-pack="feather"
              icon="icon-plus"
              color="success"
              v-on:click="createNew()"
              class="mr-3 mb-2 float-left"
              >Create New Request</vs-button
            >
          </div>
        </div>
      </vx-card>
    </div>

    <vx-card>
      <!-- TABLE ACTION ROW -->
      <div class="flex flex-wrap justify-between items-center">
        <!-- ITEMS PER PAGE -->
        <div class="mb-4 md:mb-0 mr-4 ag-grid-table-actions-left">
          <vs-dropdown vs-trigger-click class="cursor-pointer">
            <div
              class="p-4 border border-solid d-theme-border-grey-light rounded-full d-theme-dark-bg cursor-pointer flex items-center justify-between font-medium"
            >
              <span class="mr-2"
                >{{ currentPage * limit - (limit - 1) }} -
                {{
                  dataCount - currentPage * limit > 0
                    ? currentPage * limit
                    : dataCount
                }}
                of {{ dataCount }}</span
              >
              <feather-icon icon="ChevronDownIcon" svgClasses="h-4 w-4" />
            </div>
            <!-- <vs-button class="btn-drop" type="line" color="primary" icon-pack="feather" icon="icon-chevron-down"></vs-button> -->
            <vs-dropdown-menu id="ddl-page-limit">
              <vs-dropdown-item id="ddl-page-limit-1" @click="fetchData(1, 20)">
                <span>20</span>
              </vs-dropdown-item>
              <vs-dropdown-item id="ddl-page-limit-2" @click="fetchData(1, 50)">
                <span>50</span>
              </vs-dropdown-item>
              <vs-dropdown-item
                id="ddl-page-limit-3"
                @click="fetchData(1, 100)"
              >
                <span>100</span>
              </vs-dropdown-item>
              <vs-dropdown-item
                id="ddl-page-limit-4"
                @click="fetchData(1, 150)"
              >
                <span>150</span>
              </vs-dropdown-item>
              <vs-dropdown-item
                id="ddl-page-limit-5"
                @click="fetchData(1, totalData)"
              >
                <span>Show All</span>
              </vs-dropdown-item>
            </vs-dropdown-menu>
          </vs-dropdown>
        </div>
        <div class="mb-4 md:mb-0 mr-4 ag-grid-table-actions-left">
            <vs-button color="success" id="btn-download-xlsx" icon-pack="feather" icon="icon-download" v-on:click="exportXLSX()" class="mr-3 mb-2 float-left">Download CSV</vs-button>
        </div>
      </div>
      <ag-grid-vue
        :gridOptions="gridOptions"
        class="ag-theme-material w-100 my-4 ag-grid-table"
        :columnDefs="columnDefs"
        :defaultColDef="defaultColDef"
        :rowData="dataTrx"
        rowSelection="multiple"
        colResizeDefault="shift"
        :animateRows="true"
        :floatingFilter="false"
        :pagination="true"
        :paginationPageSize="limit"
        :suppressPaginationPanel="true"
        :enableCellTextSelection="true"
      ></ag-grid-vue>
      <vs-pagination
        :total="totalPage"
        :max="maxPageNumbers"
        v-model="currentPage"
      />
    </vx-card>
  </div>
</template>

<script>
import vSelect from "vue-select";
import "flatpickr/dist/flatpickr.css";
import { url } from "@/configs/apiUrl";
import { AgGridVue } from "ag-grid-vue";
import "vue-simple-suggest/dist/styles.css";
import AxiosCall from "@/global/AxiosCall";
import flatPickr from "vue-flatpickr-component";
import XLSX from "xlsx";
import VueSimpleSuggest from "vue-simple-suggest";
import "@/assets/scss/vuesax/extraComponents/agGridStyleOverride.scss";
import DetailAgGridComponent from "./DeviceRequestDetail";

export default {
  components: {
    AgGridVue,
    flatPickr,
    "v-select": vSelect,
    VueSimpleSuggest,
  },
  data() {
    return {
      filter_device: "",
      request_code: null,
      device_list: [],
      device_type: [],
      dataTrx: [],
      selected_type: null,
      chosen: "",
      selected: null,
      urlx: null,
      model: null,
      mode: "input",
      loading: false,
      searchQuery: "",
      gridOptions: {},
      maxPageNumbers: 7,
      gridApi: null,
      defaultColDef: {
        sortable: true,
        editable: false,
        resizable: true,
        suppressMenu: true,
        filterParams: {
          applyButton: true,
          newRowsAction: "keep",
        },
      },
      columnDefs: [
        {
          headerName: "Request Code",
          field: "code",
          width: 200,
          filter: false,
          editable: false,
          cellRendererFramework: DetailAgGridComponent,
        },
        {
          headerName: "Quantity",
          field: "device_qty",
          width: 200,
          filter: false,
          editable: false,
        },
        {
          headerName: "Device Type",
          field: "device_type.name",
          width: 200,
          filter: false,
          editable: false,
        },
        {
          headerName: "Status",
          field: "status",
          width: 200,
          filter: false,
          editable: false,
        },
        {
          headerName: "Merchant",
          field: "merchants.full_name",
          width: 300,
          filter: false,
          editable: false,
        },
        {
          headerName: "Requested At",
          field: "created_at",
          width: 300,
          filter: false,
          editable: false,
        },
      ],
      dataDevice: [],
      dataCount: 0,
      totalPage: 0,
      page: 1,
      limit: 20,
      totalData: 1,
      isFilter: false,
    };
  },
  computed: {
    currentPage: {
      get() {
        if (this.gridApi) return this.gridApi.paginationGetCurrentPage() + 1;
        else return 1;
      },
      set(val) {
        this.fetchData(val, this.limit);
      },
    },
  },
  methods: {
    exportXLSX() {
      let newUrl = url.svd.device_request_new.list+ "/file/download?page=1&limit=100000";
      if (this.filter_device !== "" && this.filter_device !== null)
        newUrl += "&device_code=" + this.filter_device.code;
      if (this.selected_type !== "" && this.selected_type !== null)
        newUrl += "&device_type_id=" + this.selected_type.id;
      if (this.request_code !== "" && this.request_code !== null)
        newUrl += "&request_code=" + this.request_code;

      AxiosCall.Get(newUrl)
        .then((res) => {
          this.jsonToCsv = [];
          if (res.data.length !== 0) {
            for (let data of res.data) {
              this.jsonToCsv.push({
                "Request_Code": data.request_code,
                "Merchant_Name": data.merchant_name,
                "Device_Code" : data.device_code,
                "Serial_Number" : data.serial_number, 
                "Device_Type" : data.device_type_name,
                "Request_At" : data.created_at,
                "Update_At" : data.updated_at
              });
            }
          }
          let exportData = XLSX.utils.json_to_sheet(this.jsonToCsv);
          let exportDataCSV = XLSX.utils.sheet_to_csv(exportData);

          const url = window.URL.createObjectURL(new Blob([exportDataCSV]));
          const link = document.createElement("a");
          link.href = url;
          let file_name = "device-request-detail-" +  Date.now() +".csv";
          link.setAttribute("download", file_name);
          document.body.appendChild(link);
          link.click();
          link.remove();
        })
        .catch(() => {
          console.log("failed export data");
        });
    },

    openLoading() {
      this.$vs.loading({
        type: "default",
      });
    },

    resetFilter() {
      this.filter_device = null;
      this.request_code = null;
      this.selected_type = null;
      this.page = 1;
      this.limit = 20;
      this.model = null;
      this.fetchData(1, 20);
    },
    createNew() {
      this.$router.push({ path: "/device/request-devices/add" });
    },
    fetchData(page, limit) {
      this.openLoading();
      let newPage = page;
      if (this.dataCount != 0) {
        let totalPages = Math.ceil(this.dataCount / limit);
        if (page > totalPages) {
          newPage = totalPages;
        }
      }
      newPage;
      let newUrl = url.svd.device_request_new.list + "?page=" + page + "&limit=" + limit;
      if (this.filter_device !== "" && this.filter_device !== null)
        newUrl += "&device_code=" + this.filter_device.code;
      if (this.selected_type !== "" && this.selected_type !== null)
        newUrl += "&device_type_id=" + this.selected_type.id;
      if (this.request_code !== "" && this.request_code !== null)
        newUrl += "&request_code=" + this.request_code;

      AxiosCall.Get(newUrl)
        .then((resp) => {
          this.$vs.loading.close();
          this.dataTrx = [];
          if (resp.data.data.length != 0) {
            this.totalData = parseInt(resp.data.total);
            let no = (page - 1) * limit + 1;
            for (let data of resp.data.data) {
              data.no = no;
              data.device_qty = parseInt(data.device_qty);
              this.dataTrx.push(data);
              no++;
            }

            this.dataCount = resp.data.total;
            this.page = page;
            if (limit >= this.dataCount) {
              this.limit = this.dataTrx.length;
            } else {
              this.limit = limit;
            }

            this.gridApi.paginationSetPageSize(this.limit);
            this.totalPage = resp.data.lastPage;
          }
        })
        .catch((e) => {
          this.$vs.loading.close();
          console.log(e);
        });
    },
    getList() {
      let merchant = JSON.parse(localStorage.getItem("userInfo")).merchant;
      let merchantid =
        merchant.id !== undefined
          ? merchant.id
          : merchant.parent_id !== undefined
          ? merchant.parent_id
          : "";
      let urlx = this.urlx.svd.merchant.list_by_parent_id + "/" + merchantid;
      if (this.model !== null) urlx += "?search_merchant=" + this.model;

      return new Promise((resolve, reject) => {
        AxiosCall.Get(urlx)
          .then((response) => {
            if (response.code !== 200) {
              reject();
            }
            let result = [];
            let i = 1;
            for (let data of response.data) {
              data.merchant_id = data.id;
              data.id = i + 1;
              let depth = "- ";
              data.name = depth.repeat(data.depth) + data.full_name;
              data.text = depth.repeat(data.depth) + data.full_name;
              data.code = data.code;
              i++;
              result.push(data);
            }
            resolve(result);
          })
          .catch((e) => {
            this.loading = false;
            reject(e);
          });
      });
    },
  },
  mounted() {
    let merchant = JSON.parse(localStorage.getItem("userInfo")).merchant;

    let merchantidquery = "";

    let merchantid =
      merchant.id !== undefined
        ? merchant.id
        : merchant.parent_id !== undefined
        ? merchant.parent_id
        : "";

    if (merchantid !== "") merchantidquery = "?merchant_id=" + merchantid;

    AxiosCall.Get(url.svd.device.combo + merchantidquery).then((resp) => {
      this.device_list = [];
      if (typeof resp.data !== "undefined")
        for (let data of resp.data) {
          data.label = data.code;
          this.device_list.push(data);
        }
    });

    AxiosCall.Get(url.svd.device_type.selection).then((resp) => {
      if (resp.code == 200) {
        for (let data of resp.data) {
          data.label = data.name;
          delete data.name;
          this.device_type.push(data);
        }
      } else {
        this.warning("Get device type", "Fail get device type");
      }
    });

    this.gridApi = this.gridOptions.api;
    this.gridOptions.getRowStyle = function(params) {
      if (params.node.rowIndex % 2 === 0) {
        return { background: "#f9f9f9" };
      }
    };
  },
};
</script>

<style>
.vdp-datepicker input {
  padding: 0.7rem;
  font-size: 1rem;
  border-radius: 5px;
  border: 1px solid rgba(0, 0, 0, 0.2);
  color: #626262;
  width: 100%;
}

.flatpickr-input {
  padding: 0.7rem;
  font-size: 1rem;
  border-radius: 5px;
  border: 1px solid rgba(0, 0, 0, 0.2);
  color: #626262;
  width: 100%;
}

.vue-simple-suggest.designed .suggestions {
  position: absolute;
  left: 0;
  right: 0;
  top: 100%;
  top: calc(100% + 5px);
  border-radius: 3px;
  border: 1px solid #aaa;
  background-color: #fff;
  opacity: 1;
  z-index: 1000;
  overflow: scroll;
  height: 300px;
}
.cell-wrap-text {
  white-space: pre-wrap !important;
}
</style>
